import apiInvent from "../api/inventtypes";
import apiRoom from "../api/roomtypes";
import notify from "devextreme/ui/notify";
import {getResourceTypes, getRoomTypes} from "./actions";

const createError = (msg) => ({
  errors: [
    {
      target: null,
      message: msg || "Не удалсоь выполнить запрос"
    }
  ]
});

const logError = message =>
  notify(
    {
      closeOnClick: true,
      closeOnOutsideClick: true,
      message
    },
    "error"
  );

const logSuccess = message =>
  notify(
    {
      closeOnClick: true,
      closeOnOutsideClick: true,
      message
    },
    "success"
  );

  const DELETE_RESOURCE_TYPES_REQUEST = "DELETE_RESOURCE_TYPES_REQUEST";
  const DELETE_RESOURCE_TYPES_COMPLETED = "DELETE_RESOURCE_TYPES_COMPLETED";
  const DELETE_RESOURCE_TYPES_ERROR = "DELETE_RESOURCE_TYPES_ERROR";

  const DELETE_ROOM_TYPES_REQUEST = "DELETE_ROOM_TYPES_REQUEST";
  const DELETE_ROOM_TYPES_COMPLETED = "DELETE_ROOM_TYPES_COMPLETED";
  const DELETE_ROOM_TYPES_ERROR = "DELETE_ROOM_TYPES_ERROR";

  function deleteResourceTypesRequest() {
    return {
      type: DELETE_RESOURCE_TYPES_REQUEST,
      isDeletingResTypes: true
    };
  }

  function deleteResourceTypesCompleted(deletedResTypes) {
    return {
      type: DELETE_RESOURCE_TYPES_COMPLETED,
      isDeletingResTypes: false,
      deletedResTypes
    };
  }

  function deleteResourceTypesError(deletingResTypesError) {
    return {
      type: DELETE_RESOURCE_TYPES_ERROR,
      isDeletingResTypes: false,
      deletingResTypesError
    };
  }

  function deleteRoomTypesRequest() {
    return {
      type: DELETE_ROOM_TYPES_REQUEST,
      isDeletingRoomTypes: true
    };
  }

  function deleteRoomTypesCompleted(deletedRoomTypes) {
    return {
      type: DELETE_ROOM_TYPES_COMPLETED,
      isDeletingRoomTypes: false,
      deletedRoomTypes
    };
  }

  function deleteRoomTypesError(deletingRoomTypesError) {
    return {
      type: DELETE_ROOM_TYPES_ERROR,
      isDeletingRoomTypes: false,
      deletingRoomTypesError
    };
  }

  export function deleteResourceTypes(restypes) {
    return async dispatch => {
      dispatch(deleteResourceTypesRequest());

      const response = await Promise.all(
        restypes.map(id => apiInvent.deleteInventType(id))
      );

      if (response.every(({ data }) => data.success == true)) {
        dispatch(deleteResourceTypesCompleted(response));
        dispatch(getResourceTypes());
      } else {
        dispatch(deleteResourceTypesError(response));
      }
      return response;
    };
  }

  export function deleteRoomTypes(restypes) {
    return async dispatch => {
      dispatch(deleteRoomTypesRequest());

      const response = await Promise.all(
        restypes.map(id => apiRoom.deleteRoomType(id))
      );

      if (response.every(({ data }) => data.success == true)) {
        dispatch(deleteRoomTypesCompleted(response));
        dispatch(getRoomTypes());
      } else {
        dispatch(deleteRoomTypesError(response));
      }
      return response;
    };
  }

export default {
  DELETE_RESOURCE_TYPES_REQUEST,
  DELETE_RESOURCE_TYPES_COMPLETED,
  DELETE_RESOURCE_TYPES_ERROR,
  DELETE_ROOM_TYPES_REQUEST,
  DELETE_ROOM_TYPES_COMPLETED,
  DELETE_ROOM_TYPES_ERROR,

  deleteRoomTypes,
  deleteResourceTypes
};
